let list: any = {};
export const $bus = {
  $on: (event: string, fn: Function) => {
    if (!list[event]) list[event] = [];
    list[event].push(fn);
  },
  $off: (event: string) => {
    if (!list[event]) return;
    delete list[event];
  },
  $emit: (event: string, ...args: any) => {
    if (!list[event]) return;
    list[event].forEach((fn: Function) => fn(...args));
  },
};
